<template>
    <div class="d-flex justify-content-center flex-wrap py-3">
        <div class="col-12 col-sm-4 d-flex flex-wrap bg-white shadow rounded p-5">
            <div class="col-12 text-center mb-4">
                <h3>
                    {{ $t(`Auth.${this.$route.name}.RouteName`) }}
                </h3>
            </div>
            <form @submit.prevent="forgotPassword" class="col-12 d-flex flex-wrap">
                <div class="col-12 form-field mb-2">
                    <label for="email" class="mb-2">
                        <small :class="{'text-danger' : errors.email}">
                            {{ $t('Auth.ForgotPassword.email') }}
                        </small>
                        <span v-if="errors.email" class="text-danger mx-2">
                            -
                        </span>
                        <small v-if="errors.email" class="text-danger">
                            {{ errors.email }}
                        </small>
                    </label>
                    <input v-model="email" @focus="errors.email = null" name="email" type="email" class="form-control" id="email" :placeholder="$t('Auth.ForgotPassword.insert_email')" :class="{'text-danger border-danger' : errors.email}">
                </div>
                <div class="col-12 mb-2">
                    <button type="submit" class="btn btn-auth btn-auth-second w-100">
                        {{ $t('Auth.ForgotPassword.send') }}
                    </button>
                </div>
                <div class="col-12">
                <router-link to="/" class="btn btn-auth btn-auth-white w-100">
                    {{ $t('Auth.ForgotPassword.go_back') }}
                </router-link>
            </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
    name: 'ForgotPassword',
    computed: {
        ...mapGetters(['apiPath', 'omsApiKey'])
    },
    data() {
        return {
            email: null,
            errors: {}
        }
    },
    methods: {
        ...mapMutations(['setErrorFromServer']),
        forgotPassword() {
            this.$http
                .post(`${this.apiPath}/email/send_forgot_password_request`, { email: this.email }, {
                    headers: {
                        'x-api-key': this.omsApiKey
                    }
                }).then((res) => {
                    if (res.data.errors) {
                        var errors = res.data.errors
                        for (var i = 0; i < errors.length; i++) {
                            var error = errors[i]
                            if (error.path == 'email') {
                                this.errors.email = this.$t(`Auth.ForgotPassword.errors.email.${error.msg}`)
                            }
                        }
                        this.$toast.error(this.$t('toast.fields_errors'))
                        return
                    }
                    if (res.data.data) {
                        this.$toast.success(`${this.$t('toast.sent_email')} <strong>${res.data.data.to}</strong> <h6>${this.$t('toast.confirm_email')}</h6>`)
                        this.$router.replace('/')
                        return
                    } 
                    switch (res.data) {
                        case 'No Account Found':
                            this.errors.email = this.$t('Auth.ForgotPassword.errors.email.NoAccountFound')
                            this.$toast.error(this.$t('Auth.ForgotPassword.errors.email.NoAccountFound'))
                            break
                        case 'Unconfirmed Email':
                            this.errors.email = this.$t('Auth.ForgotPassword.errors.email.UnconfirmedEmail')
                            this.$toast.error(this.$t('Auth.ForgotPassword.errors.email.UnconfirmedEmail'))
                            break
                    }
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                })
        }
    }
}
</script>